import React, { useEffect, useState, useRef } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import TableViewer from "../../component/tableViewer/TableViewer";
import noImgThing from "../../assetsCon/assets/images/noImgThing.jpg";

const ChapterBin = () => {
  const [chapters, setChapters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedChapter, setSelectedChapter] = useState([]);
  const [isRestoreBtnEnabled, setIsRestoreBtnEnabled] = useState(false);
  const token = config.token;
  const navigate = useNavigate();

  //  ------For TableViewer ------
  const chaptersRef = useRef([]);
  chaptersRef.current = chapters;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  const handleCheckboxChange = (mediaId) => {
    setSelectedChapter((prevSelectedMedia) => {
      const updatedMedia = prevSelectedMedia.includes(mediaId)
        ? prevSelectedMedia.filter((id) => id !== mediaId)
        : [...prevSelectedMedia, mediaId];
      setIsRestoreBtnEnabled(updatedMedia.length > 0);
      return updatedMedia;
    });
  };
  useEffect(() => {
    console.log(selectedChapter);
  }, [selectedChapter]);

  //----------------------------------------------- select / view chapters table  -------------------------------------------------R
  // Fetch all chapters
  const fetchDelChapters = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}chapter/bin`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            //  ------For TableViewer ------
            const chaptersData = data.data.map((chapter) => ({
              status: chapter.status,
              chapter: chapter.name,
              image: chapter.icon ? chapter.icon : chapter.image_link,
              idNumber: chapter.chapterid,
            }));
            setRowData(chaptersData);
            //  ------For TableViewer ------
            setChapters(data.data);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching chapters.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchDelChapters();
  }, [token]);

  //----------------------------------------------- select / view single chapter  -------------------------------------------------R
  const btnShowHandle = async (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/viewchapter/${encodedId}`);
  };

  // ---------------------------------------------------- Delete chapter ---------------------------------------------------------D
  // Show a confirmation dialog
  const btnDeleteHandle = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to permanently delete chapter. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, permanently delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteChapter(deleteId, i);
      }
    });
  };

  //If confirm then delete chapter
  const handleDeleteChapter = async (deleteId, i) => {
    try {
      await fetch(`${config.host_url}chapter/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status === 200) {
            triggerNotification(
              "success",
              "Chapter permanently deleted successfully"
            );
            fetchDelChapters();
          } else if (data.status === 404) {
            // chapter IDs Not Found
            console.error("Chapter IDs not found");
            triggerNotification("error", "Chapter IDs not found");
          } else if (data.status === 401) {
            // Invalid Token
            console.error("Invalid token");
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            console.error("Internal server error");
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      console.error("Error deleting chapter:", error);
      triggerNotification("error", "Error deleting chapter");
    }
  };

  const restoreRestore = async () => {
    try {
      await fetch(`${config.host_url}chapter/move/3`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify({ id: selectedChapter }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(async function (data) {
          if (data.status === 200) {
            triggerNotification("success", "Chapters restored successfully");
            setSelectedChapter([]);
            setIsRestoreBtnEnabled(false);
            fetchDelChapters();
          } else if (data.status === 404) {
            console.error("Chapter IDs not found");
            triggerNotification("error", "Chapter IDs not found");
          } else if (data.status === 401) {
            console.error("Invalid token");
            triggerNotification("error", "Unauthenticated User");
          } else {
            console.error("Internal server error");
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      console.error("Error restoring chapters:", error);
      triggerNotification("error", "Error restoring chapters");
    }
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "",
      width: 50,
      checkboxSelection: true,
    },
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    {
      headerName: "Chapter",
      field: "chapter",
      width: 300,
      cellRenderer: (params) => (
        <div className=" flex py-1 ">
          <img
            src={params.data.image ? params.data.image : noImgThing}
            alt="chapter_Image"
            className="rounded h-11 w-11  mr-4"
          />
          <p className="p-0 m-0">{params.data.chapter}</p>
        </div>
      ),
    },
  ];
  return (
    <>
      <Breadcrumb txt="Manage Chapter" subpath={["Chapter Bin"]} />
      <div className="col-xxl">
        <div className="card ">
          {/* <div className="card-header d-flex align-items-center flex justify-between">
            {isRestoreBtnEnabled && (
              <button
                type="button"
                className="text-green-700 hover:text-white border border-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-5 mb-2 dark:border-green-500 dark:text-green-500 dark:hover:text-white dark:hover:bg-green-600 dark:focus:ring-green-900"
                onClick={showRestoreConfirmation}
              >
                Restore Chapters
              </button>
            )}
          </div> */}
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData.filter((row) => row.status !== 3)}
                colDefs={colDefs}
                onDelete={btnDeleteHandle}
                //for restore chapter
                fetchDataAfterAction={fetchDelChapters}
                tableTitle="Chapter Bin"
                btnTxtFor="chapters"
                btnTxtAction={["restore"]}
                actionUrl="chapter/move/3"
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ChapterBin;
